import React from "react";

const ClearIcon: React.FC = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.48438 9.34668H2.98438V4.84668"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.17188 17.8313C7.32539 18.9857 8.79539 19.7721 10.3959 20.091C11.9964 20.4099 13.6556 20.2469 15.1635 19.6227C16.6714 18.9984 17.9602 17.941 18.867 16.5842C19.7739 15.2273 20.2579 13.632 20.2579 12C20.2579 10.368 19.7739 8.7727 18.867 7.41585C17.9602 6.059 16.6714 5.00158 15.1635 4.37735C13.6556 3.75313 11.9964 3.59014 10.3959 3.90902C8.79539 4.22789 7.32539 5.0143 6.17188 6.16875L2.98438 9.34688"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

export default ClearIcon;
